import { Select, Form } from "antd";

import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
const BankListSelect = () => {
  const { data, error, loading } = useSelector(
    (state: RootState) => state.banklist
  );
  if (error) return <>something went wrong</>;
  return (
    <>
      <Form.Item
        label="Select Your Bank account"
        name="bank_account_id"
        rules={[
          {
            required: true,
            message: "Please select your bank account",
          },
        ]}
      >
        <Select
          options={data?.data?.data?.map(({ masked_account_number, id }) => ({
            label: masked_account_number,
            value: id,
          }))}
          loading={loading}
        />
      </Form.Item>
    </>
  );
};

export default BankListSelect;
